module.exports = "<div style=\"text-align:center\">\n\n  <app-card-template [navlinks]=navLinks></app-card-template >\n  \n</div>"


//////////////////
// WEBPACK FOOTER
// /home/hkk/source/crazyaboutmath/src/app/menu-procent/menu-procent.component.html
// module id = ../../../../../src/app/menu-procent/menu-procent.component.html
// module chunks = main